import { Modal } from 'bootstrap';

/**
 * Cart modal
 */
const nlModalOptions = {
	backdrop: false,
};

const nlModal = new Modal(
	document.getElementById( 'newsletter-modal' ),
	nlModalOptions
);

$( 'a.nl-trigger' ).click( ( e ) => {
	e.preventDefault();
	nlModal.show();
} );
